@if (items && form) {
  <form [formGroup]="form">
    <label name="select" [ngStyle]="{ fontSize: fontSizeRem + 'rem' }">
      <div #ref>
        <ng-content></ng-content>
        @if (label) {
          <p>{{ label }}</p>
        }
      </div>
      <!-- if there is projected content do not display the icon -->
      @if (!ref.children.length) {
        <i [class]="iconName"></i>
      }
    </label>
    <div class="custom-select">
      <select
        id="option"
        name="select"
        [ngStyle]="{ fontSize: fontSizeRem + 'rem' }"
        formControlName="select"
        [compareWith]="compareFn"
      >
        @for (item of items | keyvalue: sortOrderFn; track item) {
          <option
            [ngStyle]="item.value.style"
            [ngClass]="item.value.class"
            [ngValue]="item"
          >
            <P>{{ item.key }}</P>
          </option>
        }
      </select>
    </div>
  </form>
} @else {
  <div class="not-available">
    <div>{{ label | uppercase }}</div>
    <div>NOT AVAILABLE</div>
  </div>
}
